import tw, { styled } from 'twin.macro';

export const StyledFormGroup = styled.div<{
  name: string | undefined;
  isHidden?: boolean;
}>`
  ${tw`flex flex-col gap-[2px]`}
  ${tw`flex-1`}
  ${tw`min-w-[0]`}
  ${tw`transition-all delay-500 ease-in-out`}
  ${tw`max-h-screen`}

  ${({ isHidden }) => isHidden && tw`hidden`}
`;

export const StyledLabel = styled.label<{
  isHidden: boolean;
}>`
  ${tw`block`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-m text-primary-p1 dark:text-neutrals-n1`}

  ${({ isHidden }) => isHidden && tw`sr-only`}
`;
